import React from 'react';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
const FormattedAmount = ({ amount, ...textStyles }) => {
    if (amount) {
        return <Amount Numbers-16 numberOfLines={1} value={amount} {...textStyles}/>;
    }
    // Renders empty placeholder if amount is not defined
    return (<Text Numbers-16 numberOfLines={1}>
      {' '}
    </Text>);
};
export default FormattedAmount;
